import { OFFICIAL_SOURCES } from '../officialSources';

export const LANGTANG_DEEP_CONTENT = {
	officeLocations: [
		{
			id: 'ntb-kathmandu',
			name: 'Nepal Tourism Board — Tourist Service Center',
			address: 'Bhrikutimandap, Kathmandu',
			hours: 'Sun–Fri 09:00–17:00',
			mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Nepal+Tourism+Board+Bhrikutimandap',
			lastVerified: '2026-07-13',
		},
	],
	officialPdfs: [
		{ id: 'dnpwc', label: 'DNPWC — Langtang National Park', url: OFFICIAL_SOURCES.dnp.url, source: OFFICIAL_SOURCES.dnp },
	],
	weatherByMonth: {
		source: 'Illustrative estimates for Kyanjin Gompa (3,870m).',
		lastVerified: '2026-07-13',
		months: [
			{ month: 'Oct', namcheHigh: 10, namcheLow: -2, gorakShepHigh: 8, gorakShepLow: -8, rainMm: 25, verdict: 'Best season', trek: 'Excellent' },
			{ month: 'Nov', namcheHigh: 6, namcheLow: -6, gorakShepHigh: 4, gorakShepLow: -12, rainMm: 10, verdict: 'Cold, clear', trek: 'Excellent' },
			{ month: 'Mar', namcheHigh: 8, namcheLow: -2, gorakShepHigh: 6, gorakShepLow: -6, rainMm: 40, verdict: 'Rhododendrons', trek: 'Excellent' },
			{ month: 'Jun', namcheHigh: 14, namcheLow: 6, gorakShepHigh: 12, gorakShepLow: 2, rainMm: 300, verdict: 'Monsoon — road risk', trek: 'Avoid' },
		],
		forecastLinks: [
			{ label: 'Mountain Forecast — Langtang Lirung area', url: 'https://www.mountain-forecast.com/peaks/Langtang-Lirung/forecasts/7227' },
		],
	},
	connectivity: {
		lastVerified: '2026-07-13',
		sim: [
			{ provider: 'Ncell', recommendation: 'Best trail coverage in Langtang', whereToBuy: 'Thamel on arrival', trailSignal: 'Moderate to Kyanjin, weak at Ri' },
		],
		wifi: { kathmandu: 'Free at hotels', trail: 'Limited paid WiFi — do not rely on it' },
	},
	altitudeSickness: {
		source: OFFICIAL_SOURCES.hra,
		lastVerified: '2026-07-13',
		goldenRules: ['Do not rush ascent to Kyanjin', 'Kyanjin Ri only if well acclimatized', 'Descend if symptoms worsen'],
		symptoms: { mild: 'Headache above 3,000m', severe: 'Cannot walk straight — descend immediately' },
		prevention: ['Gradual ascent', 'Hydration', 'Extra day at Kyanjin recommended'],
		aidPosts: [],
	},
	emergencyContacts: [
		{ label: 'Tourist Police', number: '1144', note: 'Toll-free, English, 24/7', official: true },
		{ label: 'Police', number: '100', note: 'General emergency', official: true },
	],
	helicopterEvacuation: {
		lastVerified: '2026-07-13',
		costWithoutInsurance: 'USD 3,000–8,000+',
		procedure: ['Descend if possible', 'Call insurer', 'Tourist Police 1144 for coordination'],
		touristPolice: '1144',
	},
	porterGuide: {
		lastVerified: '2026-07-13',
		hiring: 'Hire through a TAAN-registered agency in Kathmandu.',
		costPerDay: 'USD 14–18 porter, USD 20–28 guide',
		weightLimit: '15 kg',
		tipping: '10–15% at trek end',
		etiquette: ['Porters need proper footwear and warm gear — report agency if not', 'Greet porters and do not rush them on steep sections'],
	},
	licensedAgencies: {
		verifyUrl: 'https://www.taan.org.np/',
		verifyLabel: 'TAAN',
		howToVerify: ['TAAN membership check'],
		redFlags: ['No office', '100% upfront'],
		agencies: [{ name: 'Kathmandu trekking agencies', area: 'Thamel', specialty: 'Langtang packages' }],
	},
	gearRentalShops: [
		{ name: 'Thamel gear rental', area: 'Kathmandu', items: 'Sleeping bags, jackets', rates: '$2–3/day' },
	],
	gpxMap: {
		description: 'Langtang Valley to Kyanjin Gompa — standard teahouse route.',
		resources: [
			{ label: 'OpenStreetMap — Langtang', url: 'https://www.openstreetmap.org/#map=12/28.200/85.550', type: 'interactive_map' },
		],
	},
	offlineDownloads: [
		{ id: 'packing', label: 'Packing checklist', type: 'checklist' },
		{ id: 'documents', label: 'Documents wallet', type: 'checklist' },
	],
	travelerFaqs: [
		{ q: 'Is Langtang rebuilt after the earthquake?', a: 'Yes — teahouses and trails restored. Trekking resumed and community depends on tourism revenue.', category: 'trail' },
		{ q: 'Langtang or Gosainkunda?', a: 'Langtang Valley is the main teahouse route. Gosainkunda is a pilgrimage extension — separate permit and timing.', category: 'planning' },
	],
};
